import React, { useContext, useEffect, useState } from "react";
import { ThemeContext } from "../../pages/qcast-logo";
import { IoArrowBack, IoChatbubbles } from "react-icons/io5";
import LoaderSvg from "../../assets/loader.svg";
import { IoMdThumbsUp } from "react-icons/io";
import blankProfile from "../../assets/blank-profile.webp";
import QcastApi from "../../api/api-qcast";
import { useSelector, useDispatch } from "react-redux";
import ReactPlayer from "react-player";
import { useMemo } from "react";

export const Search = (props) => {
  const theme = useContext(ThemeContext);
  const { bg, font } = theme;
  const { token, userId, profileName, description } = useSelector(
    (state) => state.auth
  );
  const [storeQcasts, setStoreQcasts] = useState([]);
  const [filteredQcasts, setFilteredQcasts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const { qcastQuery } = QcastApi();

  useEffect(() => {
    if (!userId) {
      props.getStarted();
      return;
    }
    qcastQuery(userId, token, ({ id, data, msg }) => {
      if (id === 200) {
        setStoreQcasts(data.publishedQcastsList);
        setFilteredQcasts(data.publishedQcastsList);
        setIsLoading(false);
      } else {
        alert(msg);
      }
    });
  }, [userId]);

  // const handleSearch = (e) => {
  //   const { value } = e.target;
  //   let matched = [];

  //   let regx = new RegExp(`^.*?${value.toLowerCase()}.*?`, "g")

  //   storeQcasts.forEach((dt) => {
  //     let cmp = dt.description.toLowerCase();
  //     if (
  //       cmp.match(regx)
  //     ) {
  //       console.log(cmp)
  //       matched.push(dt);
  //     }
  //   });
  //   console.log(matched)
  //   setFilteredQcasts(matched);
  // };

  return (
    <div className="w-[19rem] md:w-[24rem] lg:w-[29rem] rounded-[15px] flex flex-col bg-[#FFFFFF80] backdrop-blur-[50px] overflow-hidden">
      <nav className="bg-[#FFFFFF80] w-full flex flex-row justify-between px-2 items-center py-2">
        <span></span>
        <p className="col-span-2 font-medium text-[#1E3053] w-fit">Qcasts</p>
        <span></span>
      </nav>
      {/* BODY */}
      <div className="w-full px-2 md:px-4 flex flex-col space-y-3 items-center pt-4 pb-6">
        <p
          style={{ color: bg }}
          className="w-full text-center text-sm lg:text-sm self-start"
        >
          <span>{profileName}</span> <br />
          <span className="text-xs text-black">{description}</span>
        </p>

        <div
          style={{ scrollbarColor: "black", height: "280px" }}
          className={`scroll flex flex-col overflow-y-auto w-full space-y-2 max-h-[280px] rounded-b-md ${
            filteredQcasts.length === 0 || isLoading
              ? "justify-center items-center"
              : ""
          }`}
        >
          {isLoading ? (
            <div className="w-24">
              {" "}
              <img src={LoaderSvg} alt="Loader" />
            </div>
          ) : filteredQcasts.length > 0 ? (
            filteredQcasts.map((item) => (
              <SearchQuery
                key={item.qcasId}
                data={item}
                viewsearch={props.viewsearch}
              />
            ))
          ) : (
            <div> You currently have no Qcast! </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const Qcasts = (props) => {
  const theme = useContext(ThemeContext);
  const { bg, font } = theme;
  const { token } = useSelector((state) => state.auth);
  const currentQcast = useSelector((state) => state.qcast.currentQcast);
  const [isCoverImg, setIsCoverImg] = useState(true);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const { getQcastDeepCopy } = QcastApi();
  const dispatch = useDispatch();

  useEffect(() => {
    let vidFormat = [
      "mp4",
      "flv",
      "m3u8",
      "ts",
      "3gp",
      "mov",
      "avi",
      "mkv",
      "wmv",
    ];

    if (currentQcast.qcastId && currentQcast.userId) {
      getQcastDeepCopy(
        currentQcast.userId,
        currentQcast.qcastId,
        token,
        ({ id, data, msg }) => {
          if (id === 200) {
            let cover = data.coverPhoto;
            if (vidFormat.includes(cover.substring(cover.length - 3))) {
              setIsCoverImg(false);
            } else {
              setIsCoverImg(true);
            }
            dispatch({
              type: "qcast/currentQcast",
              payload: { ...data, currentVidIndex: 0 },
            });
            setIsDataLoaded(true);
          } else {
            alert(msg);
          }
        }
      );
    }
  }, [currentQcast.qcastId]);

  const displayResponses = useMemo(() => {
    if (
      currentQcast.qcastResponseList &&
      currentQcast.qcastResponseList.length > 0
    ) {
      return currentQcast.qcastResponseList.map((data, index) => (
        <CommentsQuery key={index} data={data} response={props.playresponse} />
      ));
    } else {
      return <div>No responses</div>;
    }
  }, [currentQcast.qcastResponseList]);

  return (
    <div className="w-[29rem] rounded-[15px] flex flex-col bg-[#FFFFFF80] backdrop-blur-[50px] overflow-hidden">
      <nav className="bg-[#ffffffbf] place-items-center w-full grid grid-cols-3 px-2 py-2 shadow-sm">
        <button
          className="mr-2 w-[1.2rem] h-[1.5rem] lg:w-[1.5rem] aspect-square rounded-full justify-self-start bg-[#8DACCD54] flex flex-col "
          onClick={props.back}
        >
          <IoArrowBack className="m-auto w-full fill-[#2C3037] text-xs lg:text-sm" />
        </button>
        <p className="font-medium w-fit justify-self-center text-[#1E3053]">
          Qcast
        </p>
        <span></span>
      </nav>
      {/* BODY */}
      {isDataLoaded ? (
        <div className="w-full relative flex flex-col space-y-3 items-center pt-4 pb-6">
          <div className="w-full px-2 flex flex-row lg:px-4 overflow-clip flex-shrink-0 items-center">
            <div className="w-[6rem] h-[6rem] mr-1 bg-[#c4c4c48a] rounded-full flex flex-col flex-shrink-0">
              {isCoverImg ? (
                <img
                  alt="Cover Phto"
                  src={currentQcast.coverPhoto}
                  className="w-[86%] h-[86%] aspect-square m-auto rounded-full object-cover"
                />
              ) : (
                <ReactPlayer
                  url={currentQcast.coverPhoto}
                  poster={currentQcast.coverPhoto}
                  className="rounded-full overflow-hidden"
                  width={96}
                  height={96}
                  playing={false}
                  controls={false}
                />
              )}
            </div>
            <div className="flex flex-col flex-grow space-y-4">
              <h2 className="text-base font-medium text-[#2C3037]">
                {currentQcast.title}
              </h2>
              <div className="flex items-center space-x-2">
                <button
                  onClick={props.play}
                  style={{ backgroundColor: bg, color: font }}
                  className="w-fit shadow-md text-xs py-1 px-8 rounded-full"
                >
                  Review
                </button>
                <button
                  onClick={props.respond}
                  style={{ backgroundColor: bg, color: font }}
                  className="w-fit shadow-md text-xs py-1 px-8 rounded-full"
                >
                  Respond
                </button>
              </div>
            </div>
          </div>
          <div className="w-full bg-[#FFFFFF80] h-10 flex-row flex items-center px-2 lg:py-1 space-x-10">
            <span className="flex flex-row items-center space-x-1 text-base">
              <IoChatbubbles color={bg} className="text-lg" />

              <p style={{ color: bg }} className="leading-[initial]">
                <span className="font-medium text-black">
                  {currentQcast.qcastResponseList.length}
                </span>{" "}
                Responses
              </p>
            </span>
            <span className="flex flex-row items-center space-x-1 text-base">
              <IoMdThumbsUp color={bg} className="text-lg" />
              <p style={{ color: bg }} className="leading-[initial]">
                <span className="font-medium text-black">
                  {currentQcast.insightCount || 0}
                </span>{" "}
                Likes
              </p>
            </span>
          </div>
          <p className="w-fit self-start font-bold mx-2 text-[#2C3037]">
            Qcast Responses
          </p>
          <div className="scroll flex flex-col overflow-y-auto overflow-x-hidden px-6 pb-4 w-full space-y-2 mr-2 h-[180px] rounded-b-md">
            {displayResponses}
          </div>
        </div>
      ) : (
        <div className="scroll flex flex-col overflow-y-auto overflow-x-hidden px-6 w-full gap-2 mr-2 h-[450px] rounded-b-md justify-center items-center">
          <div className="w-24">
            {" "}
            <img src={LoaderSvg} alt="Loader" />{" "}
          </div>
        </div>
      )}
    </div>
  );
};

const SearchQuery = (props) => {
  const theme = useContext(ThemeContext);
  const { bg } = theme;
  const [isCoverImg, setIsCoverImg] = useState(true);

  const dispatch = useDispatch();

  // this part can be improve
  useEffect(() => {
    let cover = props.data.coverPhoto;
    let vidFormat = [
      "mp4",
      "flv",
      "m3u8",
      "ts",
      "3gp",
      "mov",
      "avi",
      "mkv",
      "wmv",
    ];

    if (vidFormat.includes(cover.substring(cover.length - 3))) {
      setIsCoverImg(false);
    } else {
      setIsCoverImg(true);
    }
  }, [props.data.coverPhoto]);

  const handleViewQcast = (e) => {
    e.preventDefault();
    dispatch({
      type: "qcast/currentQcast",
      payload: {
        userId: props.data.userId,
        qcastId: props.data.qcasId,
      },
    });
    props.viewsearch();
  };

  return (
    <button
      className="flex flex-row w-full overflow-clip flex-shrink-0 space-x-1"
      onClick={handleViewQcast}
    >
      <div className="w-[5rem] h-[5rem] mr-1 flex flex-col aspect-square flex-shrink-0 overflow-hidden rounded-full border-[.35rem] border-[#FFFFFF80]">
        {isCoverImg ? (
          <div
            className="w-full h-full m-auto  bg-cover bg-no-repeat bg-center"
            style={{ backgroundImage: `url(${props.data.coverPhoto})` }}
          ></div>
        ) : (
          <ReactPlayer
            url={props.data.coverPhoto}
            poster={props.data.coverPhoto}
            className="option rounded-full overflow-hidden border-[.35rem] border-[#FFFFFF80]"
            width={80}
            height={80}
          />
        )}
      </div>
      <div className="h-[5rem] flex flex-col flex-grow justify-center space-y-2">
        <h2 className="text-xs lg:text-sm font-medium self-start text-left text-[#2C3037]">
          {props.data.description}
        </h2>

        <span className="flex flex-row space-x-6 text-xs lg:text-sm">
          <p className="flex flex-row items-center text-[#515A6B]">
            <IoChatbubbles color={bg} className="" />

            <span className="mt-[2px]">
              {" "}
              {props.data.interviewCount} Responses{" "}
            </span>
          </p>
          <p className="flex flex-row items-center text-[#515A6B]">
            <IoMdThumbsUp color={bg} className="" />
            {/* 24 */}
            <span className="mt-[2px]">{props.data.insightCount} Likes</span>
          </p>
        </span>
      </div>
    </button>
  );
};

const CommentsQuery = (props) => {
  const theme = useContext(ThemeContext);
  const { bg } = theme;
  const dispatch = useDispatch();

  const handleViewResponse = () => {
    dispatch({ type: "qcast/currentResponse", payload: props.data });
    props.response();
  };

  return (
    <button
      className="flex flex-row w-full overflow-clip flex-shrink-0"
      onClick={handleViewResponse}
    >
      <div className="relative w-[6rem] h-[6rem] lg:w-[6rem] mr-1 flex flex-col aspect-square flex-shrink-0">
        <img
          alt=""
          className="w-[6rem] h-[6rem] lg:w-[6rem] border-2 border-[white] aspect-square m-auto rounded-full object-cover"
          src={props.data.profilePicAnswerer}
          onError={(e) => (e.target.src = blankProfile)}
        />
        <img
          alt=""
          className="w-[1.5rem] h-[1.5rem] lg:w-[2.3rem] lg:h-[2.3rem] border-2 border-[white] aspect-square m-auto rounded-full absolute bottom-0 right-0 object-cover"
          src={props.data.profilePicQcaster}
        />
      </div>
      <div className="flex flex-col flex-grow ml-1 h-full justify-center items-start">
        <p className="text-sm text-[#515A6B]">{props.data.responseDate}</p>
        <h2 className="text-sm font-medium text-[#2C3037] text-start">
          {props.data.responseTitle}
        </h2>

        <p style={{ color: bg }} className="text-sm mt-1">
          {props.data.responsorProfileName}
        </p>
      </div>
    </button>
  );
};
